import { c as _c } from "react/compiler-runtime";
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { ReactNode } from 'react';
interface ContentLoaderProps {
  message?: string;
  disableMessage?: boolean;
}
export const ContentLoader = (props: ContentLoaderProps) => {
  const {
    t
  } = useTranslation();
  const {
    message: label = `${t('styra.status.loading', {
      capitalize: true
    })}...`
  } = props;
  return <Container>
      <CircularProgress size={50} sx={{
      color: 'primary.30'
    }} />
      {!props.disableMessage ? <Typography sx={{
      mt: 1,
      maxWidth: 300,
      textAlign: 'center',
      color: 'neutral.dark'
    }}>
          {label}
        </Typography> : null}
    </Container>;
};
interface ContentErrorProps {
  message?: string;
  title?: string;
  children?: ReactNode;
}
export const ContentError = props => {
  const $ = _c(13);
  const {
    t
  } = useTranslation();
  const {
    message: t0,
    title,
    children
  } = props;
  let t1;
  if ($[0] !== t || $[1] !== t0) {
    t1 = t0 === undefined ? t("styra.message.error_get", {
      item: t("styra.item.page_one")
    }) : t0;
    $[0] = t;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const label = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ErrorRoundedIcon sx={{
      color: "neutral.main",
      fontSize: 64
    }} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = title ? <Typography variant="h6" sx={{
      textAlign: "center",
      color: "neutral.dark"
    }}>{title}</Typography> : null;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maxWidth: 400,
      textAlign: "center",
      color: "neutral.dark"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== label) {
    t5 = <Typography sx={t4}>{label}</Typography>;
    $[7] = label;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = children ? children : null;
  let t7;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t6) {
    t7 = <Container>{t2}{t3}{t5}{t6}</Container>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
const Container = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      height: "80%",
      minHeight: 200,
      justifyContent: "center",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Stack spacing={1} sx={t1}>{children}</Stack>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};